import { useSearchspringContext } from '../fetchers/provider'
import { useOption } from './useOption'
export const useFilters = () => {
  const { refine } = useSearchspringContext()

  const activeFilters = useOption('filters', {
    defaultValue: new Set(),
    syncWithURL: true
  })

  const handleToggleFilter = (filter) => {
    const filters = new Set(activeFilters)
    const targetFilters = filter.split(',')

    targetFilters.forEach((target) => {
      if (filters.has(target)) filters.delete(target)
      else filters.add(target)
    })

    refine('filters', filters)
    refine('page', 1)
  }

  const handleRemoveAllByField = (field) => {
    const filters = new Set(activeFilters)
    const filtersToRemove = Array.from(filters).filter((filter) => filter.includes(field))
    filtersToRemove.forEach((filter) => filters.delete(filter))

    refine('filters', filters)
    refine('page', 1)
  }

  const handleRemoveFilter = (filter) => {
    const filters = new Set(activeFilters)
    if (filters.has(filter)) filters.delete(filter)

    refine('filters', filters)
    refine('page', 1)
  }

  const handleClearFilters = () => {
    refine('filters', new Set([]))
    refine('page', 1)
  }

  return {
    handleToggleFilter,
    handleRemoveFilter,
    handleClearFilters,
    handleRemoveAllByField
  }
}
